"use strict";

module.exports = function (value) {
  return value == null;
};


//////////////////
// WEBPACK FOOTER
// ./~/yup/lib/util/isAbsent.js
// module id = 130
// module chunks = 0